import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/notifications`;

export const fetchNotifications = async () => {
  const customHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
  const response = await axiosInstance.get(API_URL, { headers: customHeaders });
  return response.data;
};

export const createNotification = async (newNotification: {
  id: string;
  receiver_id: string;
  title: string;
  message: string;
  type: string;
}) => {
  const response = await axiosInstance.post(API_URL, newNotification, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAuthToken()}`,
    },
  });
  return response.data;
};

export const readNotification = async (id: string) => {
  const customHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
  const response = await axiosInstance.get(`${API_URL}/${id}`, {
    headers: customHeaders,
  });
  return response.data;
};
